module.exports = __webpack_public_path__ + "img/5.cfef04d7.jpg";